<template>
  <div>
    <div class="page-header clear-filter" filter-color="black">
      <parallax
        class="page-header-image"
        style="background-image:url('img/13542.jpg')"
      >
      </parallax>
      <div class="container">
        <div class="content-center brand">
          <br>
          <br>
          <h1 class="h1-seo">¡Mollusca!</h1>
          <h3>Slogan</h3>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import { Progress, Parallax, Modal, Button, Pagination } from '@/components';
import { Divider } from 'element-ui'

export default {
  name: 'index',
  bodyClass: 'index-page',
  components: {
    [Progress.name]: Progress,
    [Divider.name]: Divider,
    Parallax,
    Modal,
    [Pagination.name]: Pagination,
    [Button.name]: Button
  },
  data() {
    return {
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      paginationOpen: {
          current_page: 1,
          per_page: 2
      },
      paginationClosed: {
          current_page: 1,
          per_page: 2
      },
      paginationClosedIdx: 1,
      paginationOpenIdx: 1,
      projectsOpen: [],
      projectsClosed: [],
      api_files: this.$store.state.api
    }
  },
  created() {
    this.getOpen()
  },
  methods: {
    toggleInfoWindow: function(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.text;
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  },
  watch: {
  }
};
</script>
<style>
</style>
